<template>
    <v-card flat class="score-trans">
        <v-container fluid>
            <v-row dense v-if="Array.isArray(bookings)">
                <v-col cols="12">
                    <div class="small-font ml-4 mb-2"><b>Today's bookings <span v-if="Array.isArray(bookings)">({{ this.bookings.length }})</span></b></div>
                    <left_panel_bookings_table :bookings="this.bookings" :height_correction="this.height_correction"/>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

import left_panel_bookings_table from '@/components/dashboard/sections/left_panel_bookings_table.vue';

export default {    
    props: {
        bookings: Array,
        height_correction: Number,
    },    
    components: {
        left_panel_bookings_table,
    }, 
}

</script>

<style scoped>
    .score-trans {
        background: transparent !important;
    }
</style>